import { AfterViewInit, Component, OnInit, ViewChild } from "@angular/core";
import { FormArray, FormBuilder, FormGroup, NgForm, Validators } from "@angular/forms";
import { AuthService } from "../../main/auth.service";
import { ArkUserType, SupportTicketStatusModel, SupportTicketStatusViewModel } from "../../core/api/models";
import { TicketStatusApiService } from "../../core/api/services";
import { Utils } from "../../core/utils";
import { AlertService } from "../../shared/services/alert.service";
import { Table } from "primeng/table";

@Component({
  selector: 'app-ticket-status',
  templateUrl: './ticket-status.component.html',
  standalone: false
})
export class TicketStatusComponent implements OnInit, AfterViewInit {
  pageTitle = 'Ticket Statuses';

  @ViewChild('itemForm') itemForm!: NgForm;
  @ViewChild('dt1') table?: Table;

  filter: any = {};
  list: any = undefined;
  loadingList: boolean = true;
  loading: boolean = false;
  currentItem?: SupportTicketStatusModel;
  itemFormGroup!: FormGroup;

  get GitHub_Statuses() {
    return this.itemFormGroup.controls["GitHub_Statuses"] as FormArray;
  }
  constructor(
    private authService: AuthService,
    private alertService: AlertService,
    private apiService: TicketStatusApiService,
    private formBuilder: FormBuilder) {
  }

  ngOnInit(): void {
    this.authService.checkIfAutorized([ArkUserType.Admin]);

    this.itemFormGroup = this.formBuilder.group({
      SupportTicketStatus: ['', [Validators.required, Validators.maxLength(100)]],
      GitHub_Statuses: this.formBuilder.array([]),
      Archived: [false, []],
    });
        
  }


  ngAfterViewInit(): void {
  }

  loadTable(event: any) {
    if (event || !this.filter) {
      this.filter = Utils.normalizePrimeDatatableEvent(event || this.filter || { filters: {} });
    }

    this.loadingList = true;
    this.apiService.List({ body: this.filter })
      .forEach(result => {
        this.list = result;
        this.loadingList = false;
      }).catch(err => {
        this.alertService.error(Utils.getAjaxError(err));
        this.loadingList = false;
      });
  }

  clear(table: Table) {
    this.table = table;
    table.clear();
  }

  addItem() {
    this.currentItem = {
      ID: 0,
      Archived: false
    } as SupportTicketStatusModel;
    this.load();
  }

  onRowEditInit(item: SupportTicketStatusViewModel) {
    this.loadingList = true;

    this.apiService.Get({ body: { id: item.SupportTicketStatusID || 0 } })
      .forEach(data => {
        this.loadingList = false;
        this.currentItem = data;
        this.load();
      }).catch(err => {
        this.loadingList = false;
        this.alertService.error(Utils.getAjaxError(err));
      });
  }

  onRowDeleteInit(item: SupportTicketStatusViewModel) {
    this.alertService.confirm('Confirm', `Archive ${item.SupportTicketStatus}?`).subscribe(response => {
      if (!response) {
        return;
      }

      this.apiService.Delete({ body: { id: item.SupportTicketStatusID || 0 } })
        .forEach(() => {
          this.loadTable(null);
          this.alertService.success('Status archived');
        }).catch(err => {
          this.alertService.error(Utils.getAjaxError(err));
        });
    });
  }

  load() {
    if (!this.currentItem)
      return;
    if (this.itemForm)
      this.itemForm.resetForm();
    if (this.itemFormGroup)
      this.itemFormGroup.clearValidators();

    this.GitHub_Statuses.clear();

    //this.itemFormGroup.patchValue(this.currentItem);
    

    var xItems = [] as any[];
    if (this.currentItem.GitHub_Statuses)
      for (var p of this.currentItem.GitHub_Statuses) {
        this.GitHub_Statuses.push(this.newSubItem());
        xItems.push(p);
      }

    this.itemFormGroup.setValue({
      GitHub_Statuses: xItems, // this.currentItem?.GitHub_Statuses,
      SupportTicketStatus: this.currentItem?.SupportTicketStatus || '',
      Archived: this.currentItem?.Archived || false,
    });

  }

  cancel() {
    this.currentItem = undefined;
    if (this.itemForm)
      this.itemForm.resetForm();
  }

  save() {
    if (!this.currentItem || this.itemFormGroup.invalid) {
      return;
    }
    
    this.loading = true;
    const formValue = this.itemFormGroup.value;
    /*
    formValue.GitHub_Statuses = [];
    for (var item of formValue.GitHub_Statuses) {
      if (!item.Item || !item.Item.ID)
        continue;
      formValue.GitHub_Statuses.push(item.Item.ID);
    }
    delete formValue.GitHub_Statuses;
    */
    const model = {
      ...this.currentItem,
      ...formValue
    } as SupportTicketStatusModel;

    console.info(model);

    this.apiService.Save({ body: model })
      .forEach(saved => {
        this.loading = false;
        this.currentItem = saved;
        this.loadTable(null);
        this.alertService.success('Status saved');
      }).catch(err => {
        this.loading = false;
        this.alertService.error(Utils.getAjaxError(err));
      });
  }

  newSubItem() {
    return this.formBuilder.control('', { validators: [Validators.required, Validators.minLength(2)] });
  }
  addSubItem() {
    this.GitHub_Statuses.push(this.newSubItem());
  }
  deleteSubItem(taskIndex: number) {
    this.GitHub_Statuses.removeAt(taskIndex);
  }
}
